import logo from "./../../assets/images/logo.png";
import React, { useState, useEffect } from "react";

export default function Header() {
  const [burgerMenuVisible, setBurgerMenuVisible] = useState(false);
  const headerData = [ "Главная", "Наша цель", "Команда" ];

  const burgerClick = () => {
    const burgerMenu = document.querySelector(".header-burger-menu-mob-btn");
    setBurgerMenuVisible(!burgerMenuVisible);
    burgerMenu.setAttribute("data-state", burgerMenuVisible ? "" : "active");
  };

  const burgerClickCloser = (event) => {
    if (!event.target.matches(".header-menu-wrapper-mob, .header-menu-wrapper-mob *")) {
      setBurgerMenuVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", burgerClickCloser);
  }, []);

  return (
    <header>
      <img src={ logo } alt="logo"/>
      <div className="header-links-wrapper">
        { headerData.map(item =>
          <nav key={ item } id={ item }>
            <span onClick={ () =>
              document.getElementById(
                item.split(/\s+/).map(word => word[0].toLowerCase() + word.substring(1)).join(""))
                .scrollIntoView({block: "start", behavior: "smooth"})
            }>{ item }
            </span>
          </nav>
        ) }
      </div>
      <div className="header-menu-wrapper-mob">
        <span
          className="header-burger-menu-mob-btn"
          onClick={ () => burgerClick() }
          data-state="">
        </span>
        { burgerMenuVisible &&
          <div className="header-links-wrapper-mob">
            { headerData.map(item =>
              <nav key={ item } id={ item }>
                <span onClick={ () =>
                  document.getElementById(
                    item.split(/\s+/).map(word => word[0].toLowerCase() + word.substring(1)).join(""))
                    .scrollIntoView({block: "start", behavior: "smooth"})
                }>{ item }
                </span>
              </nav>
            ) }
          </div>
        }
      </div>
    </header>
  );
}
